module.exports = __webpack_public_path__ + "img/pic-donation.ad145e4.svg";